import 'bootstrap';
import Swal from 'sweetalert2'

$(function () {

    let isLogin = true; // 暫時使用
    ifMemberLogin();


    // event：
    // ================================================================================================
    // 會員是登入狀態時
    function ifMemberLogin() {
        if (isLogin == true) {
            // header
            $('.navbar_userBtn').children('.navbar_linkdown_list')
                .html('')
                .append("<p class='border-top'><a href='../view/member_center.html'>會員中心</a></p>")
                .append("<p class='border-top'><a href='../view/member_orderList.html'>訂單紀錄</a></p>")
                .append("<p class='logout_btn'>登出</p>")

            // menu_mobile
            $('.menu_mobile_link').remove(".not_member")
            $('.menu_mobile_first')
                .after("<div class='menu_mobile_link logout_btn'>登出</div>")
                .after("<div class='menu_mobile_link'><a href='../view/member_orderList.html'>訂單紀錄</a></div>")
                .after("<div class='menu_mobile_link'><a href='../view/member_center.html'>會員中心</a></div>")

            // navber_mobile
            $('#navbar_member_m > a').prop("href", "../view/member_center.html");
            $('#navbar_msg_m > a').prop("href", "../view/member_message.html");
            $('#navbar_orderList_m > a').prop("href", "../view/member_orderList.html");
        }
    }


    // 購物車是有商品狀態時
    function showCartNumIcon() {
        let isCartEmpty = false; // 之後這邊改成購物車的length
        if (isCartEmpty == true) {
            $('.navbar_userCart').css({ 'display': 'none' })
        }
    }

    // event：
    // ================================================================================================
    // 加入喜愛清單
    $('.hover_icon_addFavorite,.product_detail_addFavorite_btn').on('click', function (event) {
        // Alert
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: '已加入喜愛清單',
            showConfirmButton: false,
            timer: 1500
        })
    });

    // 加入購物車
    $('.product_detail_addCart_btn,.modal_addCart_btn').on('click', function (event) {

        // 開啟購物車ICON數字
        showCartNumIcon()
        // 重製數量
        $('.modal_product_amount').val(1);
        // Alert
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: '已加入購物車',
            showConfirmButton: false,
            timer: 1500
        })
    });

    // 加減數量(加入購物車)
    $('.modal_amount_dash').on('click', function () {
        let nowAmount = parseInt($('.modal_product_amount').val())
        if (nowAmount == 1) {
            return
        }
        nowAmount = nowAmount - 1
        $('.modal_product_amount').val(nowAmount);
    });

    $('.modal_amount_plus').on('click', function () {
        let nowAmount = parseInt($('.modal_product_amount').val())
        nowAmount = nowAmount + 1
        $('.modal_product_amount').val(nowAmount);
    });

    // Model(加入購物車) 重製數量
    $('#addCartModal').on('hidden.bs.modal', function () {
        $('.modal_product_amount').val(1);
    });

});





